import React from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import useCountdown from '../useCountdown';
import { Container, Frame, FrameContainer, Time, Title } from './styles';

function CountdownGenshinSimple({ data, styles }) {
  const haveTitle = !!data.title;

  const fontFamilyTimer = FONT_FAMILY[styles?.timer?.font || 'notoSans'];
  const fontFamilyTitle = FONT_FAMILY[styles?.title?.font || 'notoSans'];

  const [hours, minutes, seconds] = useCountdown({
    audioUrl: data.audioUrl,
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <FontFamilyHeader family={fontFamilyTimer} />
      <FontFamilyHeader family={fontFamilyTitle} />
      <Container>
        {haveTitle && (
          <Title
            style={{
              color: styles?.title?.color,
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
            }}
          >
            {data.title}
          </Title>
        )}
        <FrameContainer>
          <Frame>
            <svg
              width="330"
              height="111"
              viewBox="0 0 330 111"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M327 46.5V13H326C320.477 13 316 8.52285 316 3V3H14V3C14 8.52285 9.52285 13 4 13H3C3 47.048 3 64.952 3 99H202.702"
                stroke={styles?.timer?.color}
                strokeWidth="5"
                strokeLinecap="square"
              />
              <path
                d="M4.5 8C3.94917 6.34752 2.65248 5.05083 1 4.5C2.65248 3.94917 3.94917 2.65248 4.5 1C5.05083 2.65248 6.34752 3.94917 8 4.5C6.34752 5.05083 5.05083 6.34752 4.5 8Z"
                fill={styles?.timer?.color}
              />
              <path
                d="M325.5 8C324.949 6.34752 323.652 5.05083 322 4.5C323.652 3.94917 324.949 2.65248 325.5 1C326.051 2.65248 327.348 3.94917 329 4.5C327.348 5.05083 326.051 6.34752 325.5 8Z"
                fill={styles?.timer?.color}
              />
              <path
                d="M213.286 97.7526L224.715 108.038L235.001 98.8955L224.715 89.7526L219.572 94.324"
                stroke={styles?.timer?.color}
                strokeWidth="4"
              />
              <path
                d="M223.572 98.8955L213.286 89.7526L203 98.8955L213.286 108.038L218.429 103.467"
                stroke={styles?.timer?.color}
                strokeWidth="4"
              />
            </svg>
          </Frame>
          <Time
            style={{
              color: styles?.timer?.color,
              fontFamily: fontFamilyTimer?.family,
              fontSize: styles?.timer?.size,
              letterSpacing: styles?.timer?.letterSpacing,
              lineHeight: styles?.timer?.size
                ? `${styles?.timer?.size}px`
                : undefined,
            }}
          >
            {`${hours}:${minutes}:${seconds}`}
          </Time>
        </FrameContainer>
      </Container>
    </>
  );
}

CountdownGenshinSimple.propTypes = {
  data: PropTypes.shape({
    audioUrl: PropTypes.string,
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    timer: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

CountdownGenshinSimple.defaultProps = {
  data: {
    audioUrl: null,
    status: 'paused',
    time: [],
    title: 'Time Remaining',
  },
  styles: {
    timer: {
      color: '#DB7855',
      font: 'notoSans',
      letterSpacing: 1,
      size: 64,
    },
    title: {
      color: '#DB7855',
      font: 'notoSans',
      letterSpacing: 1,
      size: 38,
    },
  },
};

export default CountdownGenshinSimple;
